module.exports = __webpack_public_path__ + "img/classiccar.d19ab0ad.jpg";